/*
 * Project: LegalPlace assistant
 * File: src/app/env.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

/**
 * This class help to bypass the problimatic of detecting browsers' information in execution time
 * So I initialize the browser's information and execution environment here.
 */
class LpEnvironment {
  constructor() {
    this.detectMobility();
    this.detectMobileDevice();
    this.detectOrientation();
    this.detectSize();
  }

  /**
     * detects if the device is mobile or not
     */
  detectMobility() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.is_mobile = true;
    } else {
      this.is_mobile = false;
    }
  }

  /**
     * Mobile type detection
     */
  detectMobileDevice() {
    this.mobile_device = 'NO';
    if (LpEnvironment.isAndroid()) this.mobile_device = 'Android';
    if (LpEnvironment.isWebOS()) this.mobile_device = 'WebOS';
    if (LpEnvironment.isiPhone()) this.mobile_device = 'iPhone';
    if (LpEnvironment.isiPad()) this.mobile_device = 'iPad';
    if (LpEnvironment.isiPod()) this.mobile_device = 'iPod';
    if (LpEnvironment.isBlackBerry()) this.mobile_device = 'BlackBerry';
    if (LpEnvironment.isIEMobile()) this.mobile_device = 'IEMobile';
    if (LpEnvironment.isOperaMini()) this.mobile_device = 'OperaMini';
  }

  /**
     * ... is it android
     */
  static isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  /**
     * ... is it WebOS
     */
  static isWebOS() {
    return /webOS/i.test(navigator.userAgent);
  }

  /**
     * ... is it an iPhone
     */
  static isiPhone() {
    return /iPhone/i.test(navigator.userAgent);
  }

  /**
     * ... is it an iPad
     */
  static isiPad() {
    return /iPad/i.test(navigator.userAgent);
  }

  /**
     * ... is it an iPod
     */
  static isiPod() {
    return /iPod/i.test(navigator.userAgent);
  }

  /**
     * ... is it a blackBerry
     */
  static isBlackBerry() {
    return /BlackBerry/i.test(navigator.userAgent);
  }

  /**
     * ... is it an internet explorer llaaaaah yousterna
     */
  static isIEMobile() {
    return /IEMobile/i.test(navigator.userAgent);
  }

  /**
     * is it an Opera Mini?
     */
  static isOperaMini() {
    return /Opera Mini/i.test(navigator.userAgent);
  }


  /**
     * Detetcts the orientation of the device
     * @returns {string} "landscape-*" | "portrait-*"
     */
  detectOrientation() {
    this.orientation = (window.screen && window.screen.orientation && window.screen.orientation.type) ? window.screen.orientation.type : 'none';
  }

  /**
     * This is to bypass the mobile device problems
     */
  detectSize() {
    this.client_zone = {
      height: -1,
      width: -1,
    };
    if (this.is_mobile) {
      this.client_zone.height = window.screen.availHeight;
      this.client_zone.width = window.screen.availWidth;
    } else {
      this.client_zone.height = window.innerHeight;
      this.client_zone.width = window.innerWidth;
    }
  }
}


export default LpEnvironment;



// WEBPACK FOOTER //
// ./src/app/env.js